if (!customElements.get("location-modal")) {
  customElements.define(
    "location-modal",
    class LocationModal extends HTMLElement {
      constructor() {
        super();
        this.tokenName = "localePopup";

        this.submit = this.querySelector(".js-submit");
        this.continue = this.querySelector(".js-continue");
        this.close = this.querySelector(".js-close");
        this.redirectionStoreFlag = this.querySelector(".js-flag-icon");
        this.suggestionCountry = this.querySelector(".js-country-name");
        this.suggestionCode = this.querySelectorAll(".js-target-code");
        this.route =  window.Shopify.routes.root;
        this.suggestions = {
          language: window.Shopify.locale,
          country: "",
          code: "",
        }
        this.locale = {
          code: "",
          language: window.Shopify.locale
        }

        // Fires init function
        this.init();
      }

      connectedCallback() {
        this.continue.addEventListener("click", () => this.submitForm(this.suggestions));
        this.submit.addEventListener("click", () => this.submitForm(this.locale));

        this.close.addEventListener("click", () => {
          this.setToken(this.locale);
          this.closeModal();
        });

        subscribe(PUB_SUB_EVENTS.locationChange, data => {
          data.type === "country" ? this.locale.code = data.value : this.locale.language = data.value;
        });
      }

      async init() {
        // checks if the cookie was already set, which is set once users makes a decision on a popup
        if (this.getToken(this.tokenName)) return;

        // Fetches user locale
        await this.checkRegion();

        // Updates popup content
        this.updatePopupContent();

        this.checkRegion();

        if (this.sameRegion === true) return;

        // Opens a popup
        this.openModal();
      }

      async checkRegion() {
        await fetch(window.shopUrl + "/browsing_context_suggestions.json")
          // await fetch('/browsing_context_suggestions.json') // use for development
          .then((response) => response.json())
          .then((response) => {
            this.suggestions.country = response?.detected_values?.country?.name;
            this.suggestions.code = response?.detected_values?.country?.handle;

            if (response.suggestions.length) {
              this.suggestions.language = response.suggestions.length?.parts?.language?.handle;
            }
          }).then(() => {
            if (this.route === "/" && this.suggestions.language === "en") {
              this.sameRegion = true;
            } else if (this.route.contains(this.suggestions.language)) {
              this.sameRegion = true;
            }
          });
      }

      updatePopupContent() {
        const url = `https://raw.githubusercontent.com/Fostr-io/fostr_assets/main/country_flags/circle/${this.suggestions.code.toLowerCase()}-circle.svg`;
        const flag = this.redirectionStoreFlag.querySelector("image");
        // Generates an SVG flag for the redirect to button
        flag.href.baseVal = url;

        // Update continue button and description text.
        this.suggestionCountry.innerText = this.suggestions.country;
        this.suggestionCode.forEach(el => el.innerText = this.suggestions.code);
      }

      submitForm(location) {
        this.setToken(location);
        this.closeModal();

        const formId = crypto.randomUUID();
        const formHtml = `
          <form id="${formId}" action="/localization" method="POST" hidden>
            <input name="_method" value="PUT">
            <input name="country_code" value="${location.code}">
            <input name="language_code" value="${location.language}">
          </form>
        `;

        document.body.insertAdjacentHTML("beforeend", formHtml);
        document.getElementById(formId).submit();
      }

      openModal() {
        this.classList.add("location-modal--active");
      }
      closeModal() {
        this.classList.remove("location-modal--active");
      }

      setToken(location) {
        window.localStorage.setItem(this.tokenName, JSON.stringify(location));
      }

      getToken(location) {
        return window.localStorage.getItem(location);
      }
    }
  );
}
